import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { getLocalizedString } from '../../utils/i18n-utils';
import { setSmsManualSetupPhoneCode } from '../../utils/storage-utils';
import { getOktaWidgetModel } from '../../utils/widget-facade';
import OktaVerifyEnrollBaseCustomizer from './base';

export default class EnrollmentChannelDataCustomizer extends OktaVerifyEnrollBaseCustomizer {
  primaryButtonOnClick = () => {
    const oktaModel = getOktaWidgetModel();
    setSmsManualSetupPhoneCode(oktaModel.get('phoneCode'));
  };
  async shouldCustomize() {
    return (await super.shouldCustomize()) && this.context.formName === 'enrollment-channel-data';
  }

  async customize() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpManualSetup::Landing`);
    await super.customize();
    this.forgifyChannelDescription();
    this.hideSwitchChannelText();
    this.replaceComponents();
  }

  private forgifyChannelDescription() {
    const channelDescription = jQueryCourage('.o-form-fieldset-container')
      .find(`div:contains(${getLocalizedString('oie.enroll.okta_verify.channel.sms.description')})`);
    this.hideComponent(channelDescription?.[0]);
  }
}
